/* THE TEXT-FREE INSIDE TOP, DRAWN AS THE CATALOGUE'S TOP SHOT (2026-10-08).
 *
 * A design whose inside greeting was stripped (the artist catalogue's `CoverTopPlain`, with `topGreets` naming what the
 * greeting was written for) shows that greeting only on those occasions (venture decisions.md, 2026-10-08: "topGreets
 * chooses art, never an occasion"). Everywhere else a picture of its inside must be the text-free top. The catalogue
 * has a shaped picture of the inside top only WITH the greeting (`preview.top`, top-shot.webp); of the text-free top
 * it has the flat art alone, and a flat white rectangle on a white sheet does not read as a card. So the flat art is
 * drawn here exactly as the platform draws its shot, and the result stands in for `preview.top` wherever the greeting
 * does not apply: the builder's design sheet and tile (design-picker.js designTopUrl), All cards (cards-catalogue.js).
 *
 * THE SHOT, MEASURED (catalogue top-shot.webp of artist-afee8df619a545da and artist-e44c06e73ae0435d, 2026-10-08):
 * a 2400 x 2667 frame, transparent around the card; the face is the 92 x 120 mm trim, the art stretched to 2303 x 3004
 * at (48, 96) and cut off by the frame's foot; its two top corners round at r 120; the last 7% shades down to 229/255.
 * The same drawing of the greeting art (CoverTop) matches the platform's own shot to an RMSE of 1.2% in Chrome and
 * 1.6-1.7% in Firefox and WebKit (both at 600 px wide), so a text-free top sits beside the other cards' inside shots as one of them. If the platform starts
 * rendering a text-free shot of its own (a `preview.topPlain`), use that and retire this file.
 *
 * window.PP.topShot(url) -> Promise of a blob: URL, or null when the art does not load or the canvas cannot be read
 * (the catalogue answers ACAO *; callers keep the flat art then). One drawing per URL for the life of the page.
 */
(function () {
  'use strict';
  window.PP = window.PP || {};

  const FRAME = { w: 2400, h: 2667 };
  const FACE = { x: 48, y: 96, w: 2303, h: 3004, r: 120 };
  // [where in the frame's height, how dark]: 255 -> 229 at the foot, as measured.
  const SHADE = [[0.93, 0], [0.956, 0.025], [0.975, 0.063], [0.986, 0.086], [1, 0.102]];
  const made = new Map();

  function draw(img) {
    // The face at the art's own width, so nothing is upscaled: 1000 px of art makes a 1042 x 1158 picture.
    const k = img.naturalWidth / FACE.w;
    const W = Math.round(FRAME.w * k), H = Math.round(FRAME.h * k);
    const x = FACE.x * k, y = FACE.y * k, w = FACE.w * k, h = FACE.h * k, r = FACE.r * k;
    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const g = c.getContext('2d');
    g.beginPath();
    g.moveTo(x, H);
    g.lineTo(x, y + r);
    g.arcTo(x, y, x + r, y, r);
    g.lineTo(x + w - r, y);
    g.arcTo(x + w, y, x + w, y + r, r);
    g.lineTo(x + w, H);
    g.closePath();
    g.clip();
    g.fillStyle = '#FFFFFF';   // never transparent under the art: a JPEG of it would turn black (canvas, 2026-09)
    g.fillRect(x, y, w, H - y);
    g.drawImage(img, x, y, w, h);
    const grad = g.createLinearGradient(0, 0, 0, H);
    SHADE.forEach(function (s) { grad.addColorStop(s[0], 'rgba(0,0,0,' + s[1] + ')'); });
    g.fillStyle = grad;
    g.fillRect(x, SHADE[0][0] * H, w, H - SHADE[0][0] * H);
    return new Promise(function (res) {
      try {
        c.toBlob(function (b) {
          c.width = c.height = 0;
          res(b ? URL.createObjectURL(b) : null);
        }, 'image/webp', 0.92);   // Safari has no WebP encoder and hands back a PNG, which is fine
      } catch (e) { res(null); }  // a tainted canvas
    });
  }

  window.PP.topShot = function (url) {
    if (!url) return Promise.resolve(null);
    if (made.has(url)) return made.get(url);
    const p = new Promise(function (res) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.decoding = 'async';
      img.onload = function () { draw(img).then(res, function () { res(null); }); };
      img.onerror = function () { res(null); };
      img.src = url;
    });
    made.set(url, p);
    return p;
  };
})();
